import { render } from "./ControlMusic.vue?vue&type=template&id=0caa9c34"
import script from "./ControlMusic.vue?vue&type=script&lang=js"
export * from "./ControlMusic.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__